import React, { useState } from "react";

const Donate = () => {
  const [amount, setAmount] = useState("1000");
  const [customAmount, setCustomAmount] = useState("");

  const handleAmountClick = (value) => {
    setAmount(value);
    setCustomAmount("");
  };

  const handleCustomAmountChange = (e) => {
    setCustomAmount(e.target.value);
    setAmount("custom");
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-primary-dark/5 to-primary/10 text-center">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto animate-fade-in">
            <span className="inline-block text-accent font-semibold text-sm uppercase tracking-widest mb-4">
              Support Our Cause
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-heading">
              Make a Difference Today
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Your contribution helps us provide education, healthcare, and
              sustainable livelihoods to communities in need across Uttarakhand.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {/* Donation Form */}
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-gray-100">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 font-heading">
                Choose Donation Amount
              </h2>

              <div className="grid grid-cols-3 gap-4 mb-6">
                {["500", "1000", "2500", "5000", "10000", "25000"].map(
                  (val) => (
                    <button
                      key={val}
                      onClick={() => handleAmountClick(val)}
                      className={`py-3 rounded-xl font-bold text-lg transition-all duration-300 ${
                        amount === val
                          ? "bg-primary text-white shadow-md transform scale-105"
                          : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                      }`}
                    >
                      ₹{val}
                    </button>
                  )
                )}
              </div>

              <div className="mb-8">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Or Enter Custom Amount (₹)
                </label>
                <input
                  type="number"
                  value={customAmount}
                  onChange={handleCustomAmountChange}
                  onClick={() => setAmount("custom")}
                  className={`w-full px-4 py-3 rounded-xl border-2 outline-none transition-all font-bold text-lg ${
                    amount === "custom"
                      ? "border-primary ring-2 ring-primary/20"
                      : "border-gray-200 focus:border-primary"
                  }`}
                  placeholder="Enter amount"
                />
              </div>

              <h3 className="text-lg font-bold text-gray-800 mb-4">
                Your Details
              </h3>
              <div className="space-y-4 mb-8">
                <input
                  type="text"
                  placeholder="Full Name"
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-primary outline-none"
                />
                <input
                  type="email"
                  placeholder="Email Address"
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-primary outline-none"
                />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-primary outline-none"
                />
                <input
                  type="text"
                  placeholder="PAN Number (For Tax Exemption)"
                  className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-primary outline-none"
                />
              </div>

              <button className="w-full py-4 bg-gradient-to-r from-accent to-accent-light text-white rounded-xl text-xl font-bold shadow-lg hover:-translate-y-1 hover:shadow-xl transition-all duration-300">
                Proceed to Pay ₹
                {amount === "custom" ? customAmount || "0" : amount}
              </button>

              <p className="text-xs text-center text-gray-500 mt-4">
                * All donations are eligible for tax exemption under Section
                80G.
              </p>
            </div>

            {/* Bank Details & Info */}
            <div className="space-y-8">
              <div className="bg-primary/5 p-8 rounded-3xl border border-primary/10">
                <h3 className="text-xl font-bold text-primary mb-4 flex items-center gap-2">
                  <span className="text-2xl">🏦</span> Bank Transfer Details
                </h3>
                <div className="space-y-3 text-gray-700">
                  <div className="flex justify-between border-b border-primary/10 pb-2">
                    <span className="font-semibold">Account Name:</span>
                    <span>Darim NGO</span>
                  </div>
                  <div className="flex justify-between border-b border-primary/10 pb-2">
                    <span className="font-semibold">Account Number:</span>
                    <span className="font-mono">XXXXXXXXXXXX</span>
                  </div>
                  <div className="flex justify-between border-b border-primary/10 pb-2">
                    <span className="font-semibold">Bank Name:</span>
                    <span>State Bank of India</span>
                  </div>
                  <div className="flex justify-between border-b border-primary/10 pb-2">
                    <span className="font-semibold">IFSC Code:</span>
                    <span className="font-mono">SBIN000XXXX</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-semibold">Branch:</span>
                    <span>Ghansali, Tehri Garhwal</span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100">
                <h3 className="text-xl font-bold text-gray-800 mb-4">
                  Why Donate?
                </h3>
                <ul className="space-y-4">
                  {[
                    "Support education for underprivileged children",
                    "Provide healthcare to remote villages",
                    "Empower women through skill development",
                    "Promote sustainable agriculture",
                    "Ensure clean water access",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="text-green-500 mt-1">✓</span>
                      <span className="text-gray-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-accent/10 p-6 rounded-2xl border border-accent/20 flex items-center gap-4">
                <div className="text-3xl">🔒</div>
                <div>
                  <h4 className="font-bold text-gray-800">Secure Payment</h4>
                  <p className="text-sm text-gray-600">
                    Your transaction is 100% secure and encrypted.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Donate;
